const catQa = [
  {
    id: 47,
    type: "mcq",
    question: "If x + 1/x = 5, what is the value of x² + 1/x²?",
    options: ["A. 21", "B. 23", "C. 25", "D. 27"],
    answer: "B"
  },
  {
    id: 48,
    type: "tita",
    question: "A sum of ₹15,000 is invested at 8% simple interest per annum. Find the interest earned after 3 years (in ₹, number only).",
    answer: "3600"
  },
  {
    id: 49,
    type: "mcq",
    question: "The average of 5 consecutive integers is 24. What is the largest of these integers?",
    options: ["A. 24", "B. 25", "C. 26", "D. 27"],
    answer: "C"
  },
  {
    id: 50,
    type: "mcq",
    question:
      "A train 150 m long crosses a platform 250 m long in 20 seconds. What is the speed of the train in km/hr?",
    options: ["A. 54 km/hr", "B. 60 km/hr", "C. 72 km/hr", "D. 66 km/hr"],
    answer: "C"
  },
  {
    id: 51,
    type: "tita",
    question:
      "How many integers between 1 and 100 (inclusive) are divisible by either 3 or 5? (Enter a number only.)",
    answer: "47"
  },
  {
    id: 52,
    type: "mcq",
    question: "If log₂(x) = 5, what is the value of x?",
    options: ["A. 16", "B. 25", "C. 32", "D. 64"],
    answer: "C"
  },
  {
    id: 53,
    type: "mcq",
    question:
      "A can complete a task in 12 days and B can complete the same task in 18 days. Working together, how many days will they take to complete the task?",
    options: ["A. 7.2 days", "B. 6.8 days", "C. 7.5 days", "D. 8 days"],
    answer: "A"
  },
  {
    id: 54,
    type: "tita",
    question:
      "The perimeter of a rectangle is 60 cm and its length is twice its breadth. Find the area of the rectangle in cm² (number only).",
    answer: "200"
  },
  {
    id: 55,
    type: "mcq",
    question:
      "A shopkeeper marks the price of an article 40% above its cost price and then offers a 15% discount on the marked price. What is his profit percentage?",
    options: ["A. 15%", "B. 17%", "C. 19%", "D. 21%"],
    answer: "C"
  },
  {
    id: 56,
    type: "tita",
    question:
      "The present ages of A and B are in the ratio 3:5. After 6 years, the ratio of their ages becomes 2:3. Find B's present age (in years, number only).",
    answer: "30"
  },
  {
    id: 57,
    type: "mcq",
    question: "What is the remainder when 2¹⁰⁰ is divided by 7?",
    options: ["A. 1", "B. 2", "C. 4", "D. 6"],
    answer: "B"
  },
  {
    id: 58,
    type: "tita",
    question:
      "A circle has a radius of 7 cm. Find its area in cm² (use π = 22/7, number only).",
    answer: "154"
  },
  {
    id: 59,
    type: "mcq",
    question: "In how many ways can the letters of the word 'MATHS' be arranged?",
    options: ["A. 60", "B. 100", "C. 120", "D. 150"],
    answer: "C"
  },
  {
    id: 60,
    type: "mcq",
    question: "Two dice are thrown together. What is the probability that the sum of the numbers is 7?",
    options: ["A. 1/6", "B. 1/12", "C. 1/9", "D. 5/36"],
    answer: "A"
  },
  {
    id: 61,
    type: "tita",
    question:
      "A mixture contains milk and water in the ratio 4:1, totalling 25 litres. How many litres of water must be added to make the ratio of milk to water 1:1? (number only)",
    answer: "15"
  },
  {
    id: 62,
    type: "mcq",
    question:
      "A boat's speed downstream is 20 km/hr and upstream is 12 km/hr. What is the speed of the boat in still water?",
    options: ["A. 14 km/hr", "B. 16 km/hr", "C. 18 km/hr", "D. 20 km/hr"],
    answer: "B"
  },
  {
    id: 63,
    type: "mcq",
    question:
      "The cost price of 20 articles is equal to the selling price of 25 articles. Find the shopkeeper's profit or loss percentage.",
    options: ["A. 15% loss", "B. 20% loss", "C. 25% loss", "D. 20% profit"],
    answer: "B"
  },
  {
    id: 64,
    type: "tita",
    question: "Solve for x: 3x − 7 = 2x + 9 (number only).",
    answer: "16"
  },
  {
    id: 65,
    type: "mcq",
    question:
      "A 10 m ladder leans against a wall with its foot placed 6 m from the base of the wall. How high up the wall does the ladder reach?",
    options: ["A. 6 m", "B. 7 m", "C. 8 m", "D. 9 m"],
    answer: "C"
  },
  {
    id: 66,
    type: "tita",
    question:
      "The HCF of two numbers is 6 and their LCM is 90. If one of the numbers is 18, find the other number (number only).",
    answer: "30"
  },
  {
    id: 67,
    type: "tita",
    question:
      "A can complete a task in 15 days and B can complete it in 10 days. They work together for 3 days, after which A leaves. In how many more days will B alone finish the remaining work? (number only)",
    answer: "5"
  },
  {
    id: 68,
    type: "mcq",
    question:
      "Find the compound interest on ₹10,000 at 10% per annum for 2 years, compounded annually.",
    options: ["A. ₹2000", "B. ₹2100", "C. ₹2200", "D. ₹2500"],
    answer: "B"
  }
];

export default catQa;